import { differenceInMinutes } from "@eroad/helpers/differenceInMinutes";
import { isNil } from "@eroad/helpers/isNil";

import { REACT_APP_IMARDA_BASE_URL } from "../config";
import type { IUserProfile } from "../context/types";

const isLegacySessionExpiredPagesVisible = (domDocument: Document | undefined) => {
  const isLegacyExpiredPageVisible = Boolean(domDocument?.getElementById("legacysessionexpiredpage"));
  const isLegacyLoginPageVisible = Boolean(domDocument?.getElementById("loginwrapper"));
  return isLegacyExpiredPageVisible || isLegacyLoginPageVisible;
};

const getLocalSession = (): {
  userProfile: IUserProfile | null;
  token: string | null;
} | null => {
  const item = window.localStorage.getItem("token");
  if (!item) return null;

  try {
    const session = JSON.parse(item);
    if (!session.value || session.value === "") return null;
    return {
      userProfile: session.profile,
      token: session.value,
    };
  } catch (error) {
    return null;
  }
};

// Store value as global variable rather than context or redux store to avoid constant and unnecessary re-rendering
let sessionExpiryLastChecked: Date | undefined;
const isLegacySessionExpired = async (useCache: boolean = true): Promise<boolean> => {
  // In development this endpoint throws CORS which is annoying
  if (process.env.NODE_ENV !== "development") {
    const now = new Date(Date.now());

    if (!useCache || isNil(sessionExpiryLastChecked) || differenceInMinutes(now, sessionExpiryLastChecked) >= 1) {
      sessionExpiryLastChecked = now;

      const response = await fetch(`${REACT_APP_IMARDA_BASE_URL}/Admin/isUserAuthenticated`, {
        referrerPolicy: "origin",
        mode: "cors",
        credentials: "include",
        method: "GET",
      }).catch((error) => {
        return new Error("Failed to fetch", { cause: error });
      });

      if (response instanceof Error) return true;

      const responseValue = await response.text();
      if (responseValue === "False") return true;

      // if the session expires the API returns an HTML page
      const htmlDocument = new DOMParser().parseFromString(responseValue, "text/html");
      if (isLegacySessionExpiredPagesVisible(htmlDocument)) return true;
    }
  }

  return false;
};

export { getLocalSession, isLegacySessionExpired, isLegacySessionExpiredPagesVisible };
